<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Workflow Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Testing Workflow - ${sample_type.name}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['list test process']">
      <template #gated-content>
        <div>
          <h3>
            Processes
            <b-button class="float-right" variant="success" :to="`/${route_root}/${sample_type_id}/add`">
              <i class="fal fa-plus" />
            </b-button>
          </h3>
        </div>

        <WorkflowTestProcessServerTable :sample_type_id="sample_type_id" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import WorkflowTestProcessServerTable from '@/components/lab/workflows/test/WorkflowTestProcessServerTable'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'

export default {
  name: 'WorkflowTestDetail',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowTestProcessServerTable
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-search",
            linkto: `/${this.route_root}/${this.sample_type_id}/audit-trail`,
            title: "Audit Trail",
            variant: "dark",
          },
        ]
      }
    },
    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.sample_type = await getModel({
      model_type: 'sample_type',
      id: this.sample_type_id,
      message: this.$bvToast
    })

    this.sample_type ? (this.loading = false) : this.$router.back()
  }
}
</script>
